import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SegmentProductsComponent} from './segment-products/segment-products.component';
import {SegmentContentComponent} from './segment-content/segment-content.component';
import {SegmentComponent} from './segment.component';
import {SegmentHeaderComponent} from './segment-header/segment-header.component';
import { SegmentDetailsComponent } from './segment-details/segment-details.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ]
})
export class SegmentModule {
}
